//TODO: This should really sit in dotenv

const ENV_CONFIG = {
  'dashboard.leakbot.io': ['PROD', 'TluBtJuP7hlT8WedhEfyYn4g1gHOsxrr', 'prod-leakbot.uk.auth0.com', 'https://report-service.leakbot.io/api/v2'],
  'dashboard.uat-leakbot.net': ['UAT', '3pcG44WYdDakyxpc7BN6qdCI1U5Uhqut', 'uat-leakbot.uk.auth0.com', 'https://report-service.uat-leakbot.net/api/v2'],
  'dashboard.testing-leakbot.net': ['QA', 'r0AZ414kgjqIZjZv9TNa7HshwAipbqkZ', 'dev-leakbot.uk.auth0.com', 'https://report-service.testing-leakbot.net/api/v2'],
  'dashboard.local.leakbot.io': ['DEV', 'r0AZ414kgjqIZjZv9TNa7HshwAipbqkZ', 'dev-leakbot.uk.auth0.com', 'https://report-service.local.leakbot.io/api/v2'],
  'localhost:8080': ['DEV', 'r0AZ414kgjqIZjZv9TNa7HshwAipbqkZ', 'dev-leakbot.uk.auth0.com', 'https://report-service.local.leakbot.io/api/v2']
};

const [envName, clientId, domain, reportServiceApiBaseUrl] = ENV_CONFIG[window.location.host] || ['PROD', 'TluBtJuP7hlT8WedhEfyYn4g1gHOsxrr', 'prod-leakbot.uk.auth0.com'];

export const ACTIVE_ENV = envName;
export const AUTH0_CLIENT_ID = clientId;
export const AUTH0_DOMAIN = domain;
export const AUTH0_CALLBACK = `${window.location.protocol}//${window.location.host}/#/callback`;
export const REPORT_SERVICE_API_BASE_URL = reportServiceApiBaseUrl;